const SET_PROPERTY = 'SET_PROPERTY_IMAGE_PICKER';

const SET_LOGO_STOCK_IMAGES = 'SET_LOGO_STOCK_IMAGES_IMAGE_PICKER';
const CLEAR_LOGO_STOCK_IMAGES = 'CLEAR_LOGO_STOCK_IMAGES_IMAGE_PICKER';

const SET_IMAGE_ELEMENT_STOCK_IMAGES = 'SET_IMAGE_ELEMENT_STOCK_IMAGES';
const CLEAR_IMAGE_ELEMENT_STOCK_IMAGES = 'CLEAR_IMAGE_ELEMENT_STOCK_IMAGES';
const SET_IMAGE_STOCK_IMAGES = SET_IMAGE_ELEMENT_STOCK_IMAGES;
const CLEAR_IMAGE_STOCK_IMAGES = CLEAR_IMAGE_ELEMENT_STOCK_IMAGES;

const SET_BACKGROUND_STOCK_IMAGES = 'SET_BACKGROUND_STOCK_IMAGES_IMAGE_PICKER';
const CLEAR_BACKGROUND_STOCK_IMAGES = 'CLEAR_BACKGROUND_STOCK_IMAGES_IMAGE_PICKER';

const SET_BACKGROUND_CATALOG_VIDEOS = 'SET_BACKGROUND_CATALOG_VIDEOS_IMAGE_PICKER';
const CLEAR_BACKGROUND_CATALOG_VIDEOS = 'CLEAR_BACKGROUND_CATALOG_VIDEOS_IMAGE_PICKER';

const SET_BACKGROUND_STOCK_VIDEOS = 'SET_BACKGROUND_STOCK_VIDEOS';
const CLEAR_BACKGROUND_STOCK_VIDEOS = 'CLEAR_BACKGROUND_STOCK_VIDEOS';

const SET_USER_ASSETS = 'SET_USER_ASSETS_IMAGE_PICKER';
const SET_USER_LOGO_ASSETS = 'SET_USER_LOGO_ASSETS_PICKER';
const SET_USER_IMAGE_ELEMENT_ASSETS = 'SET_USER_IMAGE_ELEMENT_ASSETS';
const SET_USER_IMAGE_ASSETS = SET_USER_IMAGE_ELEMENT_ASSETS;
const CLEAR_USER_ASSETS = 'CLEAR_USER_ASSETS_IMAGE_PICKER';
const REMOVE_USER_ASSET = 'REMOVE_USER_ASSET_IMAGE_PICKER';
const SET_USER_BACKGROUND_ASSETS = 'SET_USER_BACKGROUND_ASSETS';
const ADD_USER_BACKGROUND_ASSET = 'ADD_BACKGROUND_ASSET_PICKER';
const ADD_USER_LOGO_ASSET = 'ADD_LOGO_ASSET_PICKER';
const ADD_USER_IMAGE_ELEMENT_ASSET = 'ADD_USER_IMAGE_ELEMENT_ASSET';
const ADD_USER_IMAGE_ASSET = ADD_USER_IMAGE_ELEMENT_ASSET;

const SHOW_IMAGE_CROPPER = 'SHOW_IMAGE_CROPPER_IMAGE_PICKER';
const HIDE_IMAGE_CROPPER = 'HIDE_IMAGE_CROPPER_IMAGE_PICKER';

const SHOW_CATALOG_VIDEO_PREVIEW = 'SHOW_CATALOG_VIDEO_PREVIEW_IMAGE_PICKER';
const HIDE_CATALOG_VIDEO_PREVIEW = 'HIDE_CATALOG_VIDEO_PREVIEW_PICKER';

const SHOW_STOCK_VIDEO_PREVIEW = 'SHOW_STOCK_VIDEO_PREVIEW_PICKER';
const HIDE_STOCK_VIDEO_PREVIEW = 'HIDE_STOCK_VIDEO_PREVIEW_PICKER';

const OPEN_PREMIUM_VIDEOS_DIALOG = 'OPEN_PREMIUM_VIDEOS_DIALOG_IMAGE_PICKER';
const CLOSE_PREMIUM_VIDEOS_DIALOG = 'CLOSE_PREMIUM_VIDEOS_DIALOG_IMAGE_PICKER';

export default {
    SET_PROPERTY,
    REMOVE_USER_ASSET,
    SET_LOGO_STOCK_IMAGES,
    CLEAR_LOGO_STOCK_IMAGES,
    SET_IMAGE_ELEMENT_STOCK_IMAGES,
    CLEAR_IMAGE_ELEMENT_STOCK_IMAGES,
    SET_IMAGE_STOCK_IMAGES,
    CLEAR_IMAGE_STOCK_IMAGES,
    SET_BACKGROUND_STOCK_IMAGES,
    CLEAR_BACKGROUND_STOCK_IMAGES,
    SET_BACKGROUND_CATALOG_VIDEOS,
    CLEAR_BACKGROUND_CATALOG_VIDEOS,
    SET_BACKGROUND_STOCK_VIDEOS,
    CLEAR_BACKGROUND_STOCK_VIDEOS,
    ADD_USER_BACKGROUND_ASSET,
    ADD_USER_LOGO_ASSET,
    ADD_USER_IMAGE_ELEMENT_ASSET,
    ADD_USER_IMAGE_ASSET,
    SET_USER_ASSETS,
    SET_USER_LOGO_ASSETS,
    SET_USER_IMAGE_ELEMENT_ASSETS,
    SET_USER_IMAGE_ASSETS,
    SET_USER_BACKGROUND_ASSETS,
    CLEAR_USER_ASSETS,
    SHOW_IMAGE_CROPPER,
    HIDE_IMAGE_CROPPER,
    SHOW_CATALOG_VIDEO_PREVIEW,
    HIDE_CATALOG_VIDEO_PREVIEW,
    SHOW_STOCK_VIDEO_PREVIEW,
    HIDE_STOCK_VIDEO_PREVIEW,
    OPEN_PREMIUM_VIDEOS_DIALOG,
    CLOSE_PREMIUM_VIDEOS_DIALOG
};